@for (item of listItems; track item) {
  <span class="list-item">
    {{ item ? item.name : item }}
  </span>
}
